<template>
  <vue100vh style="position: fixed; width: -webkit-fill-available;" class="backgorundMobile">
    <v-container fluid class="pl-0 pr-0 pt-0 pb-0">
      <v-toolbar style="background-color: white !important;">
        <v-btn icon @click="toPage('/web/listmenu')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('HeaderMenubar.calendar')}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="mt-2 ml-4 mr-4 layout-height" v-if="progress" justify-center align-center>
        <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
      </v-layout>
      <v-layout row wrap align-center justify-center class="ma-2 layout-height" v-else style="overflow: hidden !important; height: 580px !important;">
        <v-row class="fill-height ma-2" v-if="progress_project">
          <v-layout row wrap justify-center align-center>
            <v-progress-circular style="margin-top: 100px;" :size="80" :indeterminate="progress_project" color="primary"></v-progress-circular>
          </v-layout>
        </v-row>
        <v-row class="fill-height ma-2" v-else>
          <v-row class="justify-center align-center">
            <v-col cols="2">
              <v-btn class="btn_prev_next" @click="$refs.calendar.prev()" small>
                {{$t('Register.Button.back')}}
              </v-btn>
            </v-col>
            <v-col cols="8" align="center">
              <v-toolbar-title>
                {{datetimecheck(date)}}
              </v-toolbar-title>
            </v-col>
            <v-col cols="2">
              <v-btn class="btn_prev_next" @click="$refs.calendar.next()" small>
                {{$t('Task.allTask.next')}}
              </v-btn>
            </v-col>
          </v-row>
        <v-calendar
          ref="calendar"
          v-model="date2"
          :now="start"
          :value="date"
          :locale="$t('Task.allTask.localepicker')"
          color="primary"
        > 
          <template slot='day' slot-scope="date">
              <template v-for="(member, index) in listdataTask">
                <v-layout :key="index" row wrap v-if="member.time == date.date">
                  <div slot="activator" style="width: 100%">
                      <template v-for="(roomname, index2) in member.task">
                        <div
                          @click="get_task_in_day(member.time, roomname), dialog = true"
                          :key="index2"
                          v-if="index2 < 1"
                          class="my-event"
                          v-html="roomname"
                        >
                        </div>
                      </template>
                      <div
                        @click="get_task_in_day(member.time), dialog = true"
                        style="cursor: pointer;"
                        v-if="member.task.length > 1"
                      >
                        <p style="font-size: 10px; padding-left: 16px; color: rgba(0, 0, 0, 0.85)" class="mb-0">{{$t('Task.allTask.detailProject')}}</p>
                      </div>
                    </div>
                </v-layout>
              </template>
          </template>
        </v-calendar>
      </v-row>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-toolbar dense dark color="#1a222c">
          <p style="font-size: 14px;" class="mt-3">{{$t('HeaderMenubar.project')}} ({{datetime(date)}})</p>
          <v-spacer></v-spacer>
          <v-icon
            right
            @click="dialog = false"
          >
            mdi-close
          </v-icon>
        </v-toolbar>
        <v-card-text class="layout-heightdialog">
          <v-row class="ma-3 justify-center align-center">
            <v-text-field
              v-model="search"
              solo
              :label="$t('Task.allTask.placeholderSearchProject')"
              clearable
              append-icon="mdi-magnify"
              class="searchBox"
              hide-details
            ></v-text-field>
          </v-row>
          <v-row class="ma-0 justify-center align-center">
            <v-layout wrap align-center justify-center fill-height style="background-color:#f4f1f1; border-radius: 20px" class="mr-1 ml-3 mt-1">
              <v-row class="taskScroll align-start justify-end fill-height" style="height: calc(100vh - 300px) !important; overflow-y: auto;">
                <v-layout v-if="progress_task" justify-center align-center  style="height: 25vh !important; ">
                  <v-progress-circular :size="40" :indeterminate="progress_task" color="primary"></v-progress-circular>
                </v-layout>
                <v-layout v-else justify-center align-center class="mr-3 ml-3 mb-4">
                  <v-row v-if="FilterListProject.length != 0" class="pa-8">
                    <v-col cols="12" v-for="(item, i) in FilterListProject" :key="i">
                      <v-row class="mt-1">
                        <h3 class="text-overflow-projectname">{{item.project_name}}</h3>
                        <v-spacer></v-spacer>
                        <span class="text-overflow-groupname">{{item.room_name}}</span>
                      </v-row>
                      <v-row>
                        <v-expansion-panels>
                          <v-expansion-panel
                            v-for="(state, index) in item.state"
                            :key="index"
                          >
                            <v-expansion-panel-header v-if="state.member.length !== 0">
                              {{state.name}}
                              <span class="span-numtask">{{$t('Task.allTask.numTask',{count: state.member.length})}}</span>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card style="width: 100%;">
                                <v-list dense>
                                  <v-list-item-group
                                    active-class="pink--text"
                                  >
                                    <template v-for="(member, indexmember) in state.member">
                                      <v-list-item :key="indexmember" @click="open_detail_task(member._id, listproject[i].tokenroom)"
                                      :class="checkpriorityTask(member.priority)">
                                        <template>
                                          <v-list-item-content>
                                            <v-list-item-title v-text="member.title"></v-list-item-title>
                                          </v-list-item-content>

                                          <v-list-item-action>
                                            <v-list-item-action-text>
                                              <v-icon color="#d8d8d8" style="font-size: 19px;" v-if="member.count_comment != '0'">fas fa-comment-dots</v-icon>
                                              <span class="ml-2 mr-2" style="color: #515050; font-size: 13px;" v-if="member.count_comment != '0'">{{member.count_comment}}</span>
                                              <span class="ml-3" style="color: #515050; font-size: 13px;">{{datetime(member.time_end)}}</span>
                                            </v-list-item-action-text>
                                          </v-list-item-action>
                                        </template>
                                      </v-list-item>

                                      <v-divider
                                        v-if="index < state.member.length - 1"
                                        :key="indexmember"
                                      ></v-divider>
                                    </template>
                                  </v-list-item-group>
                                </v-list>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-else style="height: 300px; width: 100%; justify-content: center; padding: 60px;">
                    <h4 >{{$t('Task.allTask.noCardTask')}}</h4>
                  </v-row>
                </v-layout>
              </v-row>
          </v-layout>
          </v-row>
        </v-card-text>
      </v-card>
  </v-dialog>
    <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" @edittask="edittask" @deletetask="deletetask" @commenttask="commenttask" :roomid="roomid"></DetailTask>
    <!-- <CreateProject :dialogCreateProject="dialogCreateProject" @closeCreateProject="closeCreateProject" :projectid="projectid" @createdproject="createdproject"></CreateProject> -->
</vue100vh>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
// import Rightside from '@/components/chat/layout/RightSide'
// import CreateTask from '@/components/chat/manage_task/test_created_task_dialog'
import DetailTask from '@/views/Web/Manage/task/detail_task_dialog_mo'
import vue100vh from 'vue-100vh'

var _ = require('lodash')
var moment = require('moment')
export default {
  props: {
    source: String
  },
  components: {
    // Rightside,
    // CreateTask,
    DetailTask,
    vue100vh
  },
  data () {
    return {
      // test
      // selectedDate: new Date(),
      // events: [
      //   {
      //     key: 'event-1',
      //     dates: new Date(2024, 9, 10), // 10 ตุลาคม 2024
      //     title: 'Holiday',
      //     color: 'green',
      //   },
      //   {
      //     key: 'event-2',
      //     dates: new Date(2024, 9, 10), // 10 ตุลาคม 2024
      //     title: 'Meeting',
      //     color: 'blue',
      //   },
      //   {
      //     key: 'event-3',
      //     dates: new Date(2024, 9, 24), // 24 ตุลาคม 2024
      //     title: 'Conference',
      //     color: 'orange',
      //   },
      // ],
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      // test
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTask: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: '',
      arrayEvents: null,
      date1: null,
      date2: new Date().toISOString().substr(0, 10),
      listproject: [],
      time_now: new Date().toISOString().substr(0, 10),
      time_day: new Date().toISOString().substr(0, 10),
      progress_project: false,
      list_date_task: [],
      monthLater: '',
      list_project_month: [],
      listdateCalendar: [],
      length_listproject: '',
      progress: false,

      date: new Date().toISOString().substr(0, 10),
      start: new Date().toISOString().substr(0, 10),
      listdataTask: [],
      listGetproject: [],
      checkListstr: [],
      checkdates: new Date().toISOString().substr(0, 10),
      checkroomname: '',
      progress_task: false,
      data_user: {},
    }
  },
  mounted () {
    // this.$refs.calendar.checkChange()
  },
  created () {
    // var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.token = decoded['tokenuser']
    // this.status_login = decoded['status_login']
    // this.get_data_room()
    // this.progress = true
    var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      this.data_user = user_profile['account']['profile']
      this.token = this.data_user.tokenuser
    this.get_task_in_month(this.time_now)
    // this.get_task_in_day()
    // this.get_task_in_month(this.time_now)
  },
  computed: {
    ...sync('*'),
    FilterListProject () {
      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listproject
      }
    }
  },
  watch: {
    date2 () {
      if (this.date.split('-')[1] !== this.date2.split('-')[1]) {
        this.progress_project = true
        this.checkdates = this.date
        this.date = this.date2
        this.time_day = this.date2
        localStorage.setItem('datestart', this.time_day)
        this.get_task_in_month(this.time_day)
        // this.get_task_in_day()
        // this.check_range_date()
      } else {
        this.date = this.date2
        this.checkdates = this.date2
      }
    },
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    },
    socketmessage (data) {
      // console.log(data)
      // if (data.tokenuser !== this.token) {
      //   if (data.message == 'create_task') {
      //     this.get_task_by_id(data.task_id, data.state.state_id, 'create')
      //   }
      // }
    },
    socket_deletetask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        // this.get_task_in_day()
        this.get_task_in_month(this.time_day)
      }
    },
    socket_edittask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        // this.get_task_in_day()
        this.get_task_in_month(this.time_day)
      }
    }
  },
  methods: {
    // test
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)
        console.log("first => ", first)
        console.log("second => ", second)
        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        })
      }

      this.events = events
      console.log("this.events", this.events)
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    // test
    toPage (path) {
      this.$router.push(path)
    },
    datetimecheck (timecheck) {
      if (timecheck.split('-')[1] !== this.checkdates.split('-')[1]) {
        let timeTH = Momenttime.dayjsdatethai(timecheck).split(' ')[1] + ' ' + Momenttime.dayjsdatethai(timecheck).split(' ')[2]
        let timeEN = Momenttime.dayjsdateen(timecheck).split(' ')[0] + ' ' + Momenttime.dayjsdateen(timecheck).split(' ')[2]
        return (this.$i18n.locale == 'th')? timeTH: timeEN
      } else {
        return (this.$i18n.locale == 'th')? Momenttime.dayjsdatethai(timecheck): Momenttime.dayjsdateen(timecheck)
      }
    },
    datetime (timestamp) {
      return (this.$i18n.locale == 'th')? Momenttime.dayjsdatethai(timestamp): Momenttime.dayjsdateen(timestamp)
    },
    get_task_in_month (time_now) {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_in_month', {
        tokenuser: this.token,
        time_now: time_now + ' 00:00:00.000000'
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.list_project_month = response.data.data
          this.check_range_date()
        }
      })
    },
    get_task_in_day (time) {
      this.progress_task = true
      this.listproject = []
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_in_day', {
        tokenuser: this.token,
        time_day: time + ' 00:00:00.000000'
      }).then((response) => {
        if (response.data.status === 'success') {
          // this.progress_project = false
          // this.progress = false
          this.listproject = response.data.data
          this.progress_task = false
          // this.length_listproject = this.listproject.length
          // console.log(this.listproject)
        }
      })
    },
    functionEvents (date) {
      // console.log(date)
      var month = date.split('-')[0] + '-' + date.split('-')[1]
      if (month !== this.monthLater) {
        this.monthLater = month
        this.time_now = month + '-01'
        this.get_task_in_month(this.time_now)
        return this.checkdate(date)
      } else {
        return this.checkdate(date)
      }
    },
    functionEventsColor () {
      return 'green darken-1'
    },
    check_range_date () {
      // console.log(this.list_date_task)
      this.listGetproject = []
      this.listdataTask = []
      this.listdateCalendar = []
      var time_end = '', time_start = ''
      for (var i = 0; i < this.list_project_month.length; i++) {
        for (var j = 0; j < this.list_project_month[i].state.length; j++) {
          for (var k = 0; k < this.list_project_month[i].state[j].member.length; k++) {
            time_start = this.list_project_month[i].state[j].member[k].time_start.split(' ')[0]
            time_end = this.list_project_month[i].state[j].member[k].time_end.split(' ')[0]
            this.listdateCalendar = _.union(this.listdateCalendar.concat(this.getDates(time_start, time_end, this.list_project_month[i].room_name)))
            // console.log(this.listdateCalendar)
          }
        }
      }
      this.checkIncludes()
    },
    getDates(startDate, stopDate, project) {
      // console.log(startDate, stopDate)
      var dateArray = [];
      var currentDate = moment(startDate);
      var stopDate = moment(stopDate);
      while (currentDate <= stopDate) {
        this.listGetproject.push({
          task: project,
          time: moment(currentDate).format('YYYY-MM-DD')
        }) 
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
      }
      return dateArray;
    },
    checkIncludes () {
      var arr = []
      arr = this.listGetproject.filter((value, index, self) =>
        index === self.findIndex((t, i) => (
          t.task === value.task && t.time === value.time
        ))
      )

      var output = []
      var existingIndex = []
      arr.forEach(function(item) {
        var existing = output.filter(function(v, i) {
          return v.time == item.time;
        });
        if (existing.length) {
          existingIndex = output.indexOf(existing[0]);
          output[existingIndex].task = output[existingIndex].task.concat(item.task);
        } else {
          if (typeof item.task == 'string')
            item.task = [item.task];
          output.push(item);
        }
      });

      this.listdataTask = output
      this.progress_project = false
      // console.log("listdataTask", this.listdataTask)
    },
    checkdate (date) {
      // console.log(date)
      // console.log(this.listdateCalendar)
      var test = []
      test = this.listdateCalendar
      if (test.includes(date) || test.includes(date)) {
        return true
      } else {
        return false
      }
    },
    momentday (timestamp) {
      return Momenttime.dayjsdatethai(timestamp)
    },
    commenttask (data) {
      var index = _.findIndex(this.listproject, function(o) { return o._id == data.project_id })
      var index_state = _.findIndex(this.listproject[index].state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.listproject[index].state[index_state].member, function(o) { return o._id == data.task_id })
      this.listproject[index].state[index_state].member[index_member].count_comment = data.count_comment
    },
    checkpriorityTask (priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority
      } else {
        return 'card-task-pri3'
      }
    },
    createdtask (value) {
      // this.get_task_by_id(value.task_id, value.state_id, value.event)
      this.get_task_in_day()
    },
    closeCreateTask(value) {
      this.dialogCreateTask = value
    },
    edittask (data) {
      // console.log(data)
      // this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
      this.get_task_in_day()
    },
    deletetask (data) {
      // console.log(data)
      // var index = _.findIndex(this.listproject, function(o) { return o._id == data.project_id })
      // var index_state = _.findIndex(this.listproject[index].state, function(o) { return o.state_id == data.state_id })
      // var index_member = _.findIndex(this.listproject[index].state[index_state].member, function(o) { return o._id == data.task_id })
      // this.listproject[index].state[index_state].member.splice(index_member, 1)
      // this.length_listproject = this.listproject[index].state[index_state].member.length
      this.get_task_in_day()
    },
    closeDetailTask(value) {
      this.dialogDetailTask = value
    },
    open_create_task () {
      this.dialogCreateTask = true
    },
    open_detail_task (taskid, tokenroom) {
      this.dialog = false
      // console.log(tokenroom)
      this.taskid = taskid
      this.roomid = tokenroom
      // console.log(this.StateId)
      this.dialogDetailTask = true
    },
    toChatroom () {
      this.$router.push('/mobile/room/project/' + this.$route.params.roomid)
    },
    get_data_room () {
      this.detail = {}
      this.progress = true
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.detail = response.data
          var member = []
          member = response.data.data_room
          this.member = _.filter(member, function(o) { return o.statemember == 'active' })
          this.get_task_in_day()
          // this.get_project_by_id(this.$route.params.projectid)
        }
      })
    },
    get_project_by_id (projectid) {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          this.projectid = projectid
          this.detail_project = responsed.data.data
        }
      })
    },
    get_task_by_id (taskid, stateid, stateevent, oldstate) {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = ''
          var index_member = ''
          var index = ''
          if (stateevent == 'edit') {
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == oldstate })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == taskid })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-expansion-panel-content__wrap {
  padding: 0px !important;
  flex: 1 1 auto !important;
  width: 100% !important;
}
>>>.v-expansion-panel-content {
  display: flex !important;
  width: 100% !important;
}
.btn_prev_next {
  font-size: 12px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 80px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding-left: 16px;
  cursor: pointer;
  margin-bottom: 1px;
  margin-top: 15px;
}
.day-content {
  position: relative;
  border: 1px solid #e0e0e0;
  padding: 5px;
  min-height: 80px;
}

.day-number {
  font-weight: bold;
}

.events {
  margin-top: 5px;
}

.event {
  margin: 2px 0;
  padding: 2px 5px;
  border-radius: 4px;
  color: white;
  font-size: 12px;
}

.green {
  background-color: #4caf50;
}

.blue {
  background-color: #2196f3;
}

.orange {
  background-color: #ff9800;
}

>>>.v-calendar-weekly {
  width: 100% !important;
  height: 84% !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
}
.taskScroll::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.taskScroll::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.layout-heightdialog {
  height: calc(100vh - 210px) !important;
  overflow-y: scroll !important;
  width: 100%;
}
.layout-height {
  height: calc(100vh - 128px) !important;
  overflow-y: scroll !important;
}
.span-numtask {
  border-style: solid !important;
  background-color: rgba(24, 103, 192, 0.12) !important;
  border-width: thin !important;
  border-color: rgba(24, 103, 192, 0.12) !important;
  border-radius: 6px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  color: #1867c0 !important;
  margin-left: 5px !important;
  max-width: 81px !important;
  text-align: center !important;
  padding: 2px !important;
  width: 60px !important;
}
>>>.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: none !important;
  background-color: #fff !important;
  color: rgba(0,0,0,.87) !important;
  border-radius: 15px !important;
  margin-top: 5px !important;
}
>>>.v-expansion-panel {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    list-style-type: none !important;
    padding: 0 !important;
    text-align: left !important;
    width: 100% !important;
    box-shadow: none !important;
}
>>>.v-list {
  width: 100% !important;
}
.flex-center {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}
.color-numtask {
  color: rgb(170, 170, 170) !important;
}
.scrolling-wrapper {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 29vh !important;
  max-width: 70vw !important;
  display: -webkit-inline-box !important;
  padding-top: 5vh !important;
}
/* .scrolling-wrapper::-webkit-scrollbar {
  height: 5px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
} */
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 16px!important;
  font-weight: 500!important;
  /* padding-left: 20px!important; */
  padding-top: 12px!important;
}
>>>.v-card__title--primary {
  padding-top: 18px !important;
}
.card-task-pri1 {
  border-left-color: #b3493d !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.card-task-pri2 {
  border-left-color: #fcbe55 !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.card-task-pri3 {
  border-left-color: #a0a1a3 !important;
  border-left-style: solid !important;
  border-left-width: 10px !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
.border-img {
  border-color: grey !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100px !important;
  text-align: right !important;
}
.text-overflow-projectname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 130px !important;
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-100vh {
  height: 100vh !important;
}
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  /* height: 85vh !important; */
  margin-top: 20px !important;
  border-radius: 6px !important;
  background-color: #f1f1f1 !important;
  width: 300px !important;
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.font-size-16 {
  font-size: 16px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  text-transform: none !important;
  background-color: #2561b0 !important;
  /* border-color: #2561b0 !important; */
  border-style: solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  text-transform: none !important;
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
  background-color: #fff;
  border-color: none !important;
  color: rgba(0,0,0,.87);
  /* border-radius: 20px !important; */
}
.backgorundMobile {
  background-image: linear-gradient(to right, rgba(192, 203, 250, 0.808),rgb(178, 208, 216)) !important;
}
>>> .v-calendar-weekly__day-month {
  display: none;
}
</style>
